import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';

import Col from 'components/Grid/Col';
import Row from 'components/Grid/Row';
import { ButtonContent, ButtonContainer, ButtonMiradorOrange, ButtonMiradorWhite } from 'components/Button';
import Icon from 'components/Icon';

import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalOperationContext, GlobalLoaderContext, GlobalAuthContext } from 'store/context';
import Mask from 'utils/src/mask';
import { Value, CustomRectanglePink, CustomRectangleGreen, ValueWrap, MoneyValue, Subtitle } from './styles';

export default function Page8({ match }) {

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const idOperation = match.params.idOperation;
  const fitinsurAPI = new FitinsurAPI();
  const mc = new MessageCenter();
  const history = useHistory();
  const [currentPlan, setCurrentPlan] = useState({});
  const [vlrMensal, setVrlMensal] = useState("");
  
  //redirect
  const goToLoginPage = () => {
    history.push('/login');
  };
  const goBack = () => {
    history.goBack();
  }

  const goToPage10 = (body) => {
    history.push('/embed/page10');
  };

  let messageHeader = () => {
    return (
      <div>
        <h4 style={{ fontWeight: "bold", marginTop: "10px" }}>
          {getName()}, confira a simulação que
          <br />
          preparamos para você:
        </h4>
      </div>
    );
  }

  const handleSubmit = () => {
    loading.start();
    //history.push(`/embed/page11/${idOperation}`);

    let body = {
      idOperation,
      idProductPlan: currentPlan.idProductPlan,
      optionLabel: currentPlan.productPlanName,
      currentPlan,
      add_step: 3,
    };
    
    // grava selecao do plano - add step 3
    fitinsurAPI.setAuthToken(authContext.token);
    fitinsurAPI.requestAddAction3(body)
      .then((response) => response.json())
      .then((data) => {
        loading.stop();
        if (data.ret_code === 200) {
          loading.stop();
          history.push(`/embed/page11/${idOperation}`)
        } else {
          mc.error("Erro ao escolher o plano");
        }
      })
      .catch((e) => {
        console.log(e);
        mc.error("Erro ao escolher o plano");
      })
      .finally(() => {
        loading.stop();
      });
  };

  const getName = () => {
    const name = operationContext.add2_request.personQuestionnaire.find(qst => qst.idQuestion === 189).textQuestionAnswer;
    return name.split(' ', 1);
  };

  useEffect(() => {
    
    async function loadContent() {
      const value = operationContext.add2_request.riskQuestionnaire.find(question => question.idQuestion === 194).textQuestionAnswer
      setVrlMensal(value);
      const resultPlan = operationContext.add2_response[6]; // 6 Planos
      const resultCoverage = operationContext.add2_response[7]; // 7 Coberturas
      const acceptResultFinal = operationContext.add2_response[5].acceptResultFinal; // 5

      let result = [];

      if (resultPlan && resultPlan.length > 0 && Boolean(acceptResultFinal) === Boolean(true)) {
        resultPlan.forEach((plan) => {

          // recupera valores dos items resultCoverage[].coverageCalc[].coverageItems[];
          const idProductPlan = plan.id_product_plan;
          let coverages = [], faturamin, limiteCobertura;

          // Capturando o idProductCoverage da primeira cobertura do array para recuperar o valor da fatura min mensal
          /*96*/  const idProductCoverage = resultCoverage[0].coverageCalc[0].coverageItems[0].idProductCoverage;
          faturamin = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === idProductCoverage && el.formulaName === "premioMinimoSeguroMensal").formulaExpressionResult;
          console.log("ID Plano atual ->: ", idProductPlan);
          console.log("Plano atual ->: ", plan);
          console.log("Planos ->: ", resultPlan);
          console.log("Coberturas ->: ", resultCoverage);
          console.log("fatura minima mensal ->: ", faturamin);

          resultCoverage.forEach((element) => {
            if (element.id_product_plan == idProductPlan && element.coverageCalc) {
              element.coverageCalc.forEach((elementCalc) => {
                if (elementCalc.coverageItems) {
                  elementCalc.coverageItems.forEach((item) => {

                    const formulaTaxaCobertura = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "descricaoTaxaCobertura");
                    const descricaoTaxaCobertura = (formulaTaxaCobertura ? formulaTaxaCobertura.formulaExpressionResult : "");

                    limiteCobertura = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "limiteCobertura").formulaExpressionResult;

                    if (!limiteCobertura) {
                      const resultLim = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "limiteCoberturaDefault");
                      limiteCobertura = resultLim.formulaExpressionResult;
                    };
                    /* API não retorna premioMinimoSeguroMensalDefault
                       if (!faturamin) {
                        const resultFatmin = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "premioMinimoSeguroMensalDefault");
                        faturamin = resultFatmin.formulaExpressionResult;
                        console.log("Result Fatmin: ", resultFatmin);
                      }; 
                    */
                    coverages.push({
                      coverageName: item.coverageName,
                      coverageLimit: Mask.currency({
                        value: limiteCobertura,
                        lang: "pt-br",
                        currency: 'BRL',
                        style: 'currency'
                      }),
                      coveragePremium: Mask.currency({
                        value: item.coveragePremium,
                        lang: "pt-br",
                        currency: 'BRL',
                        style: 'currency'
                      }),
                      coverageDeductible: item.deductibleDescription,
                      coverageTax: descricaoTaxaCobertura
                    });
                  });
                }
              })
            }
          });

          let resultItem = {
            productPlanName: plan.product_plan_name,
            idProductPlan: idProductPlan,
            id_operation: plan.id_operation,
            id_Product: plan.id_product,
            coverages: coverages,
            limiteCobertura: Mask.currency({
              value: limiteCobertura,
              lang: "pt-br",
              currency: 'BRL',
              style: 'currency'
            }),
            faturamin: Mask.currency({
              value: faturamin,
              lang: "pt-br",
              currency: 'BRL',
              style: 'currency'
            }),
          };

          setCurrentPlan(resultItem);
        });
      };
      console.log("processamento resultado add2", currentPlan);
    }

    loadContent();
  }, []);

  return (
    <>
      <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageHeader()}</Row>
      <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px" }} /></Row>

      <Row>
        <CustomRectanglePink>
          <div style={{ textAlign: "center", placeContent: "center" }}>
            <p style={{ margin: "0px" }}>Valor Investido</p>
            <h2 style={{ margin: "0px" }}>{currentPlan.limiteCobertura}</h2>
            <p style={{ margin: "0px" }}>Seu investimento no período</p>
          </div>
        </CustomRectanglePink>
        <CustomRectangleGreen>
          <div style={{ textAlign: "center", placeContent: "center" }}>
            <p style={{ margin: "0px" }}>Valor Investido</p>
            <h2 style={{ margin: "0px" }}>{currentPlan.limiteCobertura}</h2>
            <p style={{ margin: "0px" }}>Seu investimento no período</p>
          </div>
        </CustomRectangleGreen>
      </Row>
      <Row style={{ margin: "0px 10px", alignItems: "center", justifyContent: "center" }}>
        <Icon name="Wallet" />
        <ValueWrap>
          <h4> Quero Investir:</h4>
          <MoneyValue>
            {vlrMensal}
          </MoneyValue>
          <Subtitle>Valor mensal recorrente</Subtitle>
        </ValueWrap>
      </Row>

      <Row style={{ margin: "-30px 10px", textAlign: "center", placeContent: "center" }}>
        <h6>Os dados não mentem. <br />
          Veja abaixo o valor que irá receber no decorrer do anos
        </h6>
      </Row>

      <Row style={{ textAlign: "center", placeContent: "center" }}>
        <Col>
          <h4 style={{ fontWeight: "bold", marginTop: "10px" }}>
            Valor do Saldo de Conta individual <br />
            Você Receberá:
          </h4>
          <Value>{currentPlan.faturamin}</Value>
        </Col>
      </Row>

      <Row style={{ textAlign: "center", justifyContent: "center" }}>
        <h6>Está em dúvida? Não se preocupe, depois você poderá<br />
          alterar este valor sempre que desejar.</h6>
      </Row>

      <ButtonContainer style={{ justifyContent: "center" }}>
        <ButtonContent>
          <ButtonMiradorOrange
            type="submit"
            primary
            onClick={handleSubmit}
          >Pronto!
          </ButtonMiradorOrange>
        </ButtonContent>
      </ButtonContainer>

      <Row style={{ placeContent: "center", margin: "20px" }}>
        <ButtonMiradorWhite
          onClick={() => {
            history.goBack();
          }}
        > <p style={{ margin: "0px" }}> Ops! Quero alterar os valores <br /> e simular novamente </p>
        </ButtonMiradorWhite>
      </Row>
      <Row><br /></Row>
    </>
  )
}